import { Workbook } from "exceljs";
import { IncentiveDisbursementResponse } from "../../services/reports.service";
import { applyHeaderStyle, currencyFmt, rateFillArgb } from "./workbook-styles";

export const addIncentiveDisbursementSheets = (
	workbook: Workbook,
	data: IncentiveDisbursementResponse,
	currencyMask: string,
): void => {
	const numFmt = currencyFmt(currencyMask);

	const perEnrollment = workbook.addWorksheet("Per enrollment");
	// SIMS-5825: the export leads with the Enrollment ID. It is the key a reader
	// needs to trace a row back to the record, and without it a row whose
	// participant has no name on file (SIMS-8895 renders those blank) carries no
	// identifier at all. Note this is the export, not the on-screen table —
	// SIMS-8895 removed the column from the UI, where it was a truncated slice of
	// this same id and served no purpose.
	perEnrollment.columns = [
		{ header: "Enrollment ID", key: "enrollmentId", width: 26 },
		{ header: "Participant", key: "participantName", width: 28 },
		{ header: "Org unit", key: "orgUnit", width: 22 },
		{ header: "Researcher", key: "researcher", width: 22 },
		{ header: "Potential", key: "potential", width: 12 },
		{ header: "Earned", key: "earned", width: 12 },
		{ header: "Received", key: "received", width: 12 },
		{ header: "Engagement %", key: "engagementRate", width: 14 },
	];
	applyHeaderStyle(perEnrollment.getRow(1));

	for (const row of data.byEnrollment) {
		const r = perEnrollment.addRow(row);
		r.getCell("potential").numFmt = numFmt;
		r.getCell("earned").numFmt = numFmt;
		r.getCell("received").numFmt = numFmt;
		r.getCell("engagementRate").numFmt = "0.0";
		const rate = rateFillArgb(row.engagementRate);
		if (rate) {
			r.getCell("engagementRate").fill = {
				type: "pattern",
				pattern: "solid",
				fgColor: { argb: rate },
			};
		}
	}

	const daily = workbook.addWorksheet("Daily breakdown");
	daily.columns = [
		{ header: "Day", key: "day", width: 8 },
		{ header: "Earned", key: "earned", width: 12 },
		{ header: "Potential", key: "potential", width: 12 },
	];
	applyHeaderStyle(daily.getRow(1));

	for (const row of data.byDay) {
		const r = daily.addRow(row);
		r.getCell("earned").numFmt = numFmt;
		r.getCell("potential").numFmt = numFmt;
	}
};
